import { Suspense } from 'react';

import { PageLoader } from '@/shared/ui';
import { AppBootstraps } from './bootstraps';
import { AppGlobalOverlays } from './overlays';
import { AppErrorBoundary } from './providers';
import { AppRouter } from './router';

export default function App() {
  return (
    <AppErrorBoundary>
      <Suspense fallback={<PageLoader />}>
        <AppBootstraps />
        <AppGlobalOverlays />
        <AppRouter />
      </Suspense>
    </AppErrorBoundary>
  );
}
